import moment from "moment";

export const variantFieldMap = {
  Normal: [
    "nameOfTheShop",
    "addressOfTheShop",
    "dateOfPurchase",
    "quantityOfSample",
    "costOfSample",
    "typeOfShop",
    "photographOfInvoice",
    "photographOfShop",
    "manufacturingDatePresent",
    "manufacturingDate",
    "expiryDatePresent",
    "expiryDate",
    "brandNamePresent",
    "brandName",
    "manufacturerNamePresent",
    "manufacturersName",
    "lotNumberPresent",
    "lotNumber",
    "generalPackingPhoto",
    "manufacturerNamePhoto",
    "expiryDatePhoto",
    "packagingType",
    "packagingTypePhoto",
    "samplePackedIn",
    "fssaiLogoPresent",
    "fssaiLogoPhoto",
    "vegSymbolPresent",
    "vegSymbolPhoto",
    // "jaivikBharatSymbolPresent",
    // jaivikBharatSymbolPhoto,
    "qrCodeId",
    "qrCodePhoto",
    "sampleSealNo",
    "sampleSealPhoto",
    "samplerSelfie",
    "manufacturerPlantAddressPresent",
    "manufacturingPlantAddress",
    "fssaiLicenseNumberPresent",
    "fssaiLicenseNumber",
    "fssaiLicenseNumberPhoto",
    "countryOfOriginPresent",
    "countryOfOrigin",
    "sampleClaim",
    "sampleClaimDescription",
    "sampleClaimPhoto",
    // "validityPhoto"
  ],
  Organic: [
    "nameOfTheShop",
    "addressOfTheShop",
    "dateOfPurchase",
    "quantityOfSample",
    "costOfSample",
    "typeOfShop",
    "photographOfInvoice",
    "photographOfShop",
    "manufacturingDatePresent",
    "manufacturingDate",
    "expiryDatePresent",
    "expiryDate",
    "brandNamePresent",
    "brandName",
    "manufacturerNamePresent",
    "manufacturersName",
    "lotNumberPresent",
    "lotNumber",
    "generalPackingPhoto",
    "manufacturerNamePhoto",
    "expiryDatePhoto",
    "packagingType",
    "packagingTypePhoto",
    "samplePackedIn",
    "fssaiLogoPresent",
    "fssaiLogoPhoto",
    "vegSymbolPresent",
    "vegSymbolPhoto",
    "jaivikBharatSymbolPresent",
    "jaivikBharatSymbolPhoto",
    "qrCodeId",
    "qrCodePhoto",
    "sampleSealNo",
    "sampleSealPhoto",
    "samplerSelfie",
    "manufacturerPlantAddressPresent",
    "manufacturingPlantAddress",
    "fssaiLicenseNumberPresent",
    "fssaiLicenseNumber",
    "fssaiLicenseNumberPhoto",
    "countryOfOriginPresent",
    "countryOfOrigin",
    "sampleClaim",
    "sampleClaimDescription",
    "sampleClaimPhoto",
  ],
  Loose: [
    "nameOfTheShop",
    "addressOfTheShop",
    "dateOfPurchase",
    "quantityOfSample",
    "costOfSample",
    "typeOfShop",
    "photographOfInvoice",
    "photographOfShop",
    // "manufacturingDate",
    // "expiryDate",
    // "brandName",
    // "manufacturersName",
    // "lotNumber",
    "generalPackingPhoto",
    // "manufacturerNamePhoto",
    // "expiryDatePhoto",
    "packagingType",
    "packagingTypePhoto",
    // "samplePackedIn",
    // "fssaiLogoPresent",
    // "fssaiLogoPhoto",
    // "vegSymbolPresent",
    // "vegSymbolPhoto",
    // "jaivikBharatSymbolPresent",
    // "jaivikBharatSymbolPhoto",
    "qrCodeId",
    "qrCodePhoto",
    "sampleSealNo",
    "sampleSealPhoto",
    "samplerSelfie",
    // "manufacturingPlantAddress",
    // "fssaiLicenseNumber",
    // "fssaiLicenseNumberPhoto",
    // "countryOfOriginPresent",
    // "countryOfOrigin",
    // "sampleClaim",
    // "sampleClaimDescription",
    // "sampleClaimPhoto",
  ],
};

export function buildDefaultValues(fields, sampleDetails) {
  const defaults = {};
  fields.forEach((field) => {
    if (["manufacturingDate", "expiryDate", "dateOfPurchase"].includes(field)) {
      defaults[field] = sampleDetails?.[field]
        ? moment(sampleDetails[field], [
            "DD-MM-YYYY",
            moment.ISO_8601,
            "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ",
          ]).isValid()
          ? moment(sampleDetails[field], [
              "DD-MM-YYYY",
              moment.ISO_8601,
              "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ",
            ])
          : null
        : null;
    } else {
      defaults[field] = sampleDetails?.[field] || "";
    }
  });
  return defaults;
}
